import React, { useEffect, useState } from "react";
import API, { UPDATE_USER_FAKE, LIST_RANK } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { 
    Button, 
    InputNumber, 
    Input, 
    message,
    Table,
    Pagination,
} from "antd";
import ModalCommon from "../../components/Modal";
import Modal from 'react-bootstrap/Modal';

const TEXT = {
    username: "Tên đăng nhập",
    turn: "Số lượt đã chơi",
    rank: "Thứ hạng",
    save: "Lưu",
    action: "Hành động",
    update: "Cập nhật",
    delete: "Xóa",
    titleEdit: "Chỉnh sửa lượt chơi"
}

const RankSetting = () => {
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
    const [isShowModalEdit, setIsShowModalEdit] = useState(false);
    
    const [messageApi, contextHolder] = message.useMessage();

    const [username, setUsername] = useState();
    const [turns, setTurns] = useState();
    const [usernameEdit, setUsernameEdit] = useState();
    const [turnsEdit, setTurnsEdit] = useState();
    const [usernameDel, setUsernameDel] = useState();

    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalRecord, setTotalRecord] = useState(0);
    const locale = {
        emptyText: TEXT_DEF.text0035,
    };
    const [loading, setLoading] = useState(false);

    const dataColums = [
        {
            title: TEXT_DEF.text0002,
            dataIndex: "username",
            key: "username",
        },
        {
            title: TEXT.turn,
            key: "usedTurns",
            dataIndex: "usedTurns",
        },
        // {
        //     title: TEXT.rank,
        //     key: "rank",
        //     dataIndex: "rank",
        // },
        {
            title: 'Hành động',
            key: "action",
            align: "center",
            render: (record) =>
            (
                <div className="flex flex-row w-full items-center justify-center">
                    <span onClick={() => showModalEdit(record)} className="cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`Cập nhật`}</span>
                    <span onClick={() => showModalDel(record)} className="ml-5 cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`Xóa`}</span>
                </div>
            )
        },
    ];

    const showModalEdit = (record) => {
        setUsernameEdit(record.username);
        setTurnsEdit(record.usedTurns);
        setIsShowModalEdit(true);
    }

    const showModalDel = (record) => {
        setUsernameDel(record.username);
        setIsShowModalConfirm(true);
    }
    
    const showTotal = (total) => `Tổng cộng ${total} tài khoản`;

    const onChangePage = (page) => {
        setPage(page);
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const getListData = async () => {
        setLoading(true);
        const dataList1 = API.get(
            `${LIST_RANK}?pageSize=10&page=${page}&isFake=true`
        );

        await Promise.all([dataList1])
            .then((response) => {
                const res = response[0].data.data.data;
                if (res) {
                    let dataCV = [];
                    res?.map((item) => {
                        const user = {
                            key: item?.id,
                            username: item?.username,
                            usedTurns: item?.playCount,
                            isFake: item?.isFake,
                            rank: item?.rank,
                        };
                        dataCV.push(user);
                        return dataCV;
                    });

                    setDataList(dataCV);
                    setTotalRecord(response[0].data?.data.total);
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const handleChangeInput = (e, key) => {
        switch (key) {
            case 1: setUsername(e.target.value); return;
            case 2: setTurns(e); return;
            case 3: setTurnsEdit(e); return;
            default: return;
        }
    };

    const delAccoutFake = async () => {
        await API.delete(`${UPDATE_USER_FAKE}/${usernameDel}`).then((response) => {
            if (response.data) {
                getListData();
                setIsShowModalConfirm(false);
            }
        }).catch((error) => {
            const errorMessage = error.data?.message || "An error occurred";
            showError(errorMessage);
        });
    };

    const showError = (errorMessage) => {
        messageApi.open({
            type: 'error',
            content: errorMessage,
        });
    };

    const onCreateUserFake = async () => {
        const body = {
            username: username,
            playCount: turns
        };

        await API.post(`${UPDATE_USER_FAKE}`, body).then((response) => {
            if (response.data) {
                setIsShowModalSuccess(true);
                getListData();
            }
        }).catch((error) => {
            const errorMessage = error.data?.message || "An error occurred";
            showError(errorMessage);
        });
    };

    const updateUserFake = async () => {
        const body = {
            playCount: turnsEdit
        };

        await API.patch(`${UPDATE_USER_FAKE}/${usernameEdit}`, body).then((response) => {
            if (response.data) {
                getListData();
                setIsShowModalEdit(false);

            }
        }).catch((error) => {
            const errorMessage = error.data?.message || "An error occurred";
            showError(errorMessage);
        });
    }

    const handleShowModal = () => {
        onCreateUserFake()
    };

    const renderInput = (key, changeInput, label) => {
        return (
            <div className={`flex w-full items-center ${key !== "vip0_5" ? "mt-4" : ""}`}>
                <div className="flex w-[20%] justify-end mr-10">{label}:</div>
                <div className="w-[60%]">
                    <Input
                        key={key}
                        style={{ width: "100%" }}
                        onChange={changeInput}
                    />
                </div>
            </div>
        )
    }

    const renderInputNumer = (key, changeInput, max, label) => {
        return (
            <div className={`flex w-full items-center ${key !== "vip0_5" ? "mt-4" : ""}`}>
                <div className="flex w-[20%] justify-end mr-10">{label}:</div>
                <div className="w-[60%]">
                    <InputNumber
                        key={key}
                        style={{ width: "100%" }}
                        onChange={changeInput}
                        max={max}
                        min={-10}
                    />
                </div>
            </div>
        )
    }

    const renderUICreateUser = () => {
        return (
            <div className="flex col-8 flex-row w-full items-center justify-center mt-2">
                <div className="col-8 flex flex-col items-center justify-center">
                    {renderInput(
                        "username",
                        (e) => handleChangeInput(e, 1),
                        `${TEXT.username}`
                    )}

                    {renderInputNumer(
                        "turns",
                        (e) => handleChangeInput(e, 2),
                        1000000000, `${TEXT.turn}`
                    )}
                </div>
                <div className="col-2 flex flex-col items-center">
                    <Button type="primary" onClick={handleShowModal} disabled={!username || !turns}>
                        Lưu
                    </Button>
                </div>
            </div>
        )
    }

    const renderTableUser = () => {
        return (
            <div className="flex w-full items-center justify-center flex-col">
                    <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
                        <Table
                            key="table-user-fake"
                            locale={locale}
                            columns={dataColums}
                            dataSource={dataList}
                            loading={loading}
                            pagination={false}
                            bordered
                            style={{ width: "100%" }}
                        />
                   </div>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            marginTop: 15,
                            justifyContent: "flex-end",
                        }}
                    >
                        <Pagination
                            current={page}
                            total={totalRecord}
                            onChange={onChangePage}
                            defaultPageSize={10}
                            showSizeChanger={false}
                            showTotal={showTotal}
                        />
                    </div>
            </div>
        )
    }

    return (
        <div className="col-12">
            {contextHolder}
            <div className="col-12">
                <div className="flex w-full">
                    <div className="flex col-12 flex-col w-full items-center justify-center">
                        <h5>Tạo Tài Khoản fake</h5>
                        {renderUICreateUser()}
                        <div style={{ fontWeight: 900, margin: 20 }}>--------------------------------------------</div>
                        <h5>Danh Sách Tài Khoản Fake</h5>
                        {renderTableUser()}
                    </div>
                </div>
            </div>
            {isShowModalEdit && (
                <Modal show={isShowModalEdit} className='modal-all' onHide={() => setIsShowModalEdit(false)}>
                    <Modal.Header>
                        <div className="flex flex-col w-full items-center justify-center">
                            <h5>Cập nhật số lượt đã chơi</h5>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="flex flex-col w-full items-center justify-center">
                            {renderInputNumer(
                                "turns",
                                (e) => handleChangeInput(e, 3),
                                1000000000, `${TEXT.turn}`
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="primary" onClick={updateUserFake}>
                            Cập nhật
                        </Button>
                        <Button type="default" onClick={() => setIsShowModalEdit(false)}>
                            Đóng
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={'Tạo tài khoản fake thành công!'}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={"Bạn có chắc chắn muốn xóa tài khoản này?"}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={() => delAccoutFake()}
                    close={() => setIsShowModalConfirm(false)}
                />
      )}
        </div>
    );
};

export default RankSetting;
